import { createQueryKeys } from '@lukemorales/query-key-factory';
import { useMutation, useQuery, UseQueryOptions } from '@tanstack/react-query';
import { MenuApi } from 'api';
import type { Menu } from 'api/methods/MenuApi';

/**
 * [Menu] Query key 생성
 * --
 */
export const menuQueryKeys = createQueryKeys('menu', {
  getMenu: (idx: number, params?: { [key: string]: string | number }) => [
    idx,
    params,
  ],
  getMenus: (params?: { [key: string]: string | number }) => [params],
});

/**
 * [Menu] 메뉴 전체 조회
 * --
 */
export const useGetMenus = (
  params?: { [key: string]: string | number },
  options?: UseQueryOptions<any, any>
) => {
  const data = useQuery({
    queryKey: menuQueryKeys.getMenus(params).queryKey,
    queryFn: () => MenuApi.getMenus(params),
    ...options,
  });
  return data;
};

/**
 * [Menu] 메뉴 상세 조회
 * --
 */
export const useGetMenu = (
  idx: number,
  params?: { [key: string]: string | number },
  options?: UseQueryOptions<any, any>
) => {
  const data = useQuery({
    queryKey: menuQueryKeys.getMenu(idx, params).queryKey,
    queryFn: () => MenuApi.getMenu(idx, params),
    ...options,
  });

  return data;
};

/**
 * [Menu] 메뉴 생성
 * --
 */
export const useCreateMenu = (body: Menu) => {
  const { mutateAsync: createMenu, ...result } = useMutation({
    mutationFn: (variables: Menu) => MenuApi.createMenu(variables),
    onSuccess: (data, variables) => {},
    onError: (error) => {
      console.error(error);
    },
  });

  return { createMenu, ...result };
};

/**
 * [Menu] 메뉴 수정
 * --
 */
export const useUpdateMenu = (body: Menu) => {
  const { mutateAsync: updateMenu, ...result } = useMutation({
    mutationFn: (variables: Menu) => MenuApi.updateMenu(variables),
    onSuccess: (data, variables) => {},
    onError: (error) => {
      console.error(error);
    },
  });

  return { updateMenu, ...result };
};

/**
 * [Menu] 메뉴 삭제
 * --
 */
export const useDeleteMenu = (idx: number) => {
  const { mutateAsync: deleteMenu, ...result } = useMutation({
    mutationFn: (variables: number) => MenuApi.deleteMenu(variables),
    onSuccess: (data, variables) => {
      console.log(data, variables);
    },
    onError: (error) => {
      console.error(error);
    },
  });

  return { deleteMenu, ...result };
};

/**
 * [Menu] 메뉴 벌크 생성/수정
 * --
 */
export const useUpsertMenu = () => {
  const { mutateAsync: upsertMenu, ...result } = useMutation({
    mutationFn: (variables: Menu[]) => MenuApi.upsertBulkMenu(variables),
  });

  return { upsertMenu, ...result };
};
